<div class="record-exchange-dialog">
  <button class="close-btn" type="button" (click)="onClose()" aria-label="Close record exchange dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h2 class="dialog-title">{{ dialogTitle }}</h2>

  <form class="record-exchange-form" [formGroup]="recordExchangeForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="field-label">Trade type</label>
      <div class="options-container" role="group" aria-label="Trade type">
        <div
          class="options-items unstake-padding"
          [ngClass]="{ selected: recordExchangeForm.controls.tradeType.value === TradeTypeEnum.Buy }"
          (click)="setTradeType(TradeTypeEnum.Buy)"
        >
          <mat-icon>arrow_upward</mat-icon>
          BUY
        </div>

        <div
          class="options-items unstake-padding"
          [ngClass]="{ selected: recordExchangeForm.controls.tradeType.value === TradeTypeEnum.Sell }"
          (click)="setTradeType(TradeTypeEnum.Sell)"
        >
          <mat-icon>arrow_downward</mat-icon>
          SELL
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="text-input-wrapper disabled">
        <label>Asset</label>
        <div class="text-input-container">
          <input type="text" [value]="dialogData.currency" disabled />
        </div>
      </div>
    </div>
    <div class="form-group date-group">
      <app-date-picker
        [datePickerMode]="'dropdown'"
        [selectionMode]="'single'"
        [styleDropdown]="'custom'"
        [dateKey]="'recordExchangeDate'"
        [dateLabel]="'Date'"
        [selectedDate]="selectedTradeDate"
        (dateChange)="onDateSelected($event)"
      ></app-date-picker>
    </div>
    <div class="form-group">
      <app-text-input
        label="Amount"
        placeholder="Enter the amount of purchase"
        type="number"
        [maxLength]="maxNumberInputLength"
        formControlName="amount"
        [isInvalid]="getFieldError('amount', 'Amount') !== ''"
        [errorMessage]="getFieldError('amount', 'Amount')"
      ></app-text-input>
    </div>

    <div class="form-group">
      <app-text-input
        label="Rate"
        placeholder="Enter rate"
        type="number"
        [maxLength]="maxNumberInputLength"
        formControlName="rate"
        [isInvalid]="getFieldError('rate', 'Rate') !== ''"
        [errorMessage]="getFieldError('rate', 'Rate')"
      ></app-text-input>
    </div>

    <div class="form-group">
      <app-text-input
        label="Fees"
        placeholder="Fees"
        type="number"
        [maxLength]="maxNumberInputLength"
        formControlName="fees"
        [isInvalid]="getFieldError('fees', 'Fees') !== ''"
        [errorMessage]="getFieldError('fees', 'Fees')"
      ></app-text-input>
    </div>

    <app-button buttonVariant="record-exchange" buttonType="submit" [state]="confirmButtonState">
      {{ confirmButtonLabel }}
    </app-button>
  </form>
</div>
